module.exports = __webpack_public_path__ + "static/img/serve5.e27c52fd.png";